<script setup lang="ts">
const props = defineProps<{
  temperature: number
}>()

const label = computed(() => {
  if (props.temperature >= 500) return '🤯 Bombástica'
  if (props.temperature >= 200) return '🔥 Em Alta'
  if (props.temperature >= 50) return '✨ Boa'
  if (props.temperature >= 0) return '😊 Normal'
  return '🥶 Fraquinha'
})

const color = computed(() => {
  if (props.temperature >= 500) return 'error'
  if (props.temperature >= 200) return 'warning'
  if (props.temperature >= 50) return 'warning'
  return 'neutral'
})
</script>

<template>
  <UBadge :color="color" variant="soft" size="sm" class="font-semibold">
    {{ temperature }} · {{ label }}
  </UBadge>
</template>
